import React from "react";
import { Translate } from "react-localize-redux";

const ExportImport = ({ data, currency }) => {
    let length = data.export.length > data.import.length ? data.export.length : data.import.length;
    return (
        <React.Fragment>
            {(data.total !== 0 || data.year !== 0) && <table className="table table-report-section key-value">
                <tbody>
                    <tr>
                        <td><Translate id="Report.BasicInfo.ExportVolume" data={{ currency: currency }} /></td>
                        <td>{data.totalFormated}</td>
                        <td>[{data.year}]</td>

                    </tr>
                    <tr>
                        <td><Translate id="Report.BasicInfo.ExportSales" /></td>
                        <td>{data.shareFormated}</td>
                        <td>[{data.year}]</td>
                    </tr>
                </tbody>
            </table>
            }
            <br />
            {length > 0 &&
                <table className="table table-report-section">
                    <thead>
                        <tr>
                            <th><Translate id="Report.BasicInfo.ImportStructure" /></th>
                            <th><Translate id="Report.BasicInfo.ExportStructure" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {createTable(data)}
                    </tbody>
                </table>
            }
        </React.Fragment>
    )
}
const createTable = (data) => {
    let trs = [];
    let length = data.export.length > data.import.length ? data.export.length : data.import.length;
    for (let i = 0; i < length; i++) {
        trs.push(
            <tr key={i}>
                <td>{data.import[i] || ""}</td>
                <td>{data.export[i] || ""}</td>
            </tr>)
    }
    return trs;
}


export default ExportImport;